import { render, staticRenderFns } from "./editOrganization.vue?vue&type=template&id=7dc5e5bf&"
import script from "./editOrganization.vue?vue&type=script&lang=js&"
export * from "./editOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports